import PropTypes from 'prop-types'

function CollapseChevron ({ isOpen, className = '' }) {
  return <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'} ${className}`} />
}

CollapseChevron.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string
}

export default CollapseChevron
